/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfPatient } from '../../models/data-page-of-patient';

export interface PatientSearch$Params {
  emrpracticeId?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  dob?: string | null;
  mrn?: string | null;
  pageNumber?: number;
  SortByColumn?: string | null;
  SortByDirection?: string | null;
}

export function patientSearch(http: HttpClient, rootUrl: string, params?: PatientSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPatient>> {
  const rb = new RequestBuilder(rootUrl, patientSearch.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('lastName', params.lastName, {});
    rb.query('firstName', params.firstName, {});
    rb.query('dob', params.dob, {});
    rb.query('mrn', params.mrn, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('SortByColumn', params.SortByColumn, {});
    rb.query('SortByDirection', params.SortByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfPatient>;
    })
  );
}

patientSearch.PATH = '/patient/Search';
